import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import SecurityIcon from '@material-ui/icons/Security';

const securityHomeRouteRef = createRouteRef();

const componentFilter = (entity: { kind: string }) =>
  entity.kind.toLocaleLowerCase('en-US') === 'component';

const securityCicdFilter = (entity: {
  kind: string;
  metadata: { annotations?: Record<string, string> };
}) =>
  componentFilter(entity) &&
  Boolean(entity.metadata.annotations?.['dev.azure.com/project-repo']) &&
  !entity.metadata.annotations?.['techne.com/iac-runner'];

const securityCicdContent = EntityContentBlueprint.make({
  name: 'security-cicd',
  params: {
    path: '/ci-cd',
    title: 'CI/CD',
    filter: securityCicdFilter,
    loader: async () => {
      const { SecurityCicdContent } = await import('./SecurityCicdContent');
      return <SecurityCicdContent />;
    },
  },
});

const securityContent = EntityContentBlueprint.make({
  name: 'security',
  params: {
    path: '/security',
    title: 'Security',
    filter: componentFilter,
    loader: async () => {
      const { SecurityContent } = await import('./SecurityContent');
      return <SecurityContent />;
    },
  },
});

const securityHomePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    title: 'Home',
    icon: <SecurityIcon fontSize="inherit" />,
    routeRef: securityHomeRouteRef,
    loader: async () => {
      const { SecurityHomePage } = await import('./SecurityHomePage');
      return <SecurityHomePage />;
    },
  },
});

const securityHomeCard = EntityCardBlueprint.make({
  name: 'security-summary',
  params: {
    type: 'info',
    filter: componentFilter,
    loader: async () => {
      const { SecurityHomeCard } = await import('./SecurityHomeCard');
      return <SecurityHomeCard />;
    },
  },
});

export const securityModule = createFrontendModule({
  pluginId: 'app',
  extensions: [securityHomePage, securityContent, securityCicdContent, securityHomeCard],
});
